import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import BaseModal from 'components/BaseModal';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function EmbargoedCountryModal({ open, onClose }) {
  return (
    <BaseModal
      size="sm"
      open={open}
      title={<b>Regional Restrictions</b>}
      content={
        <Box px={2}>
          <Box mb={4}>
            <Typography>
              Apologies, this subscription is unavailable in your location at the moment since we
              are required to comply with sanction laws. You can still access our free benefits in
              the meantime.
            </Typography>
          </Box>
        </Box>
      }
      actionButton={false}
      cancelButton={true}
      cancelText="Close"
      onActionClick={onClose}
      onClose={onClose}
    />
  );
}

EmbargoedCountryModal.propTypes = Props;
